
var showdown = require("showdown"),
  converter = new showdown.Converter({ tables: true });
converter.setFlavor("github");

import Banner from "../components/Banner.vue";
import Modal from "../components/Modal.vue";
import Nav from "../components/Nav.vue";
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import axios from "axios";

export default defineComponent({
  components: {
    Banner,
    Modal,
    Nav,
  },
  setup() {
    const state = reactive({
      rules: Array,
      ruleSubsections: Array,
      sections: Array,
      result: null,
      text: "",
      html: "",
    });

    onMounted(async () => {
      const { data } = await axios.get("https://www.dnd5eapi.co/api/rules");

      state.rules = data.results;
    });

    const showRule = async (index: string) => {
      const { data } = await axios.get(
        `https://www.dnd5eapi.co/api/rules/${index}`
      );
      state.ruleSubsections = data.subsections;
    };

    // rules subsection
    const showRuleSubsection = async (index: string) => {
      const { data } = await axios.get(
        `https://www.dnd5eapi.co/api/rule-sections/${index}`
      );

      state.sections = data;
      state.text = data.desc;
      state.html = converter.makeHtml(state.text);
    };
    return { ...toRefs(state), showRule, showRuleSubsection };
  },
});
